import { Jsonld } from "../../jsonld";

export type BreadcrumbItem = {
  name: string;
  url: string;
};

export type BreadcrumbListProps = Readonly<{
  items: ReadonlyArray<BreadcrumbItem>;
}>;

export function BreadcrumbListSchema({ items }: BreadcrumbListProps): JSX.Element | null { 
  if (!items?.length) return null;
  const schemaTypeId = "jsonld_breadcrumblist_rb";
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  } as const;

  return <Jsonld id={schemaTypeId} dataSchema={data} dataQa={schemaTypeId} />;
}